import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { PermissionService } from '../../services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class AppPermissionsGuard  {
  constructor(
    private permissionService: PermissionService,
    private router: Router
  ) {}

  canActivate(next: ActivatedRouteSnapshot): boolean {
    if (next.data.permission) {
      if (!this.permissionService.hasPermission(next.data.permission)) {
        this.router.navigate(['/home']);
        return false;
      }
    }
    return true;
  }
}
